export default __webpack_public_path__ + "static/media/products.deb07f95.svg";